import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import Dashboard from '../views/Dashboard.vue';
import Login from '../views/Login.vue';
import Profile from '../views/Profile.vue';
import Calendar from '../views/Calendar.vue';
import Job from '../views/Job.vue';
import JobParts from '../views/Job/JobParts';
import JobPart from '../views/Job/JobPart';
import JobReport from '../views/Job/JobReport';

import LayoutLogin from '../layouts/Login';

Vue.use(VueRouter)

// Routes
const routes = [
	{
		path: '/',
		name: 'Dashboard',
		component: Dashboard,
		meta: {
			title: 'Übersicht',
		}
	},
	{
		path: '/:job(\\d+)',
		name: 'DashboardJob',
		component: Dashboard,
		props: true,
		meta: {
			title: 'Übersicht'
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		props: route => {
			if (route.query) {
				return {
					isPasswordReset: 'password-reset' in route.query,
					email: 'email' in route.query ? route.query.email : null
				};
			}

			return {};
		},
		meta: {
			layout: LayoutLogin,
			requiresAuth: false,
			needsConnection: true
		}
	},
	{
		path: '/calendar',
		name: 'Calendar',
		component: Calendar,
		meta: {
			title: 'Kalender'
		}
	},
	{
		path: '/profile',
		name: 'Profile',
		component: Profile,
		meta: {
			title: 'Mein Profil'
		}
	},
	{
		path: '/jobs/assembling/:jobId(\\d+)',
		name: 'JobAssemblingDetail',
		component: Job,
		props: route => {
			if (route.params.jobId) {
				route.params.jobId = parseInt(route.params.jobId);
			}

			return route.params;
		},
		meta: {
			title: 'Montage'
		}
	},
	{
		path: '/jobs/assembling/:jobId(\\d+)/parts',
		name: 'JobParts',
		component: JobParts,
		props: route => {
			if (route.params.jobId) {
				route.params.jobId = parseInt(route.params.jobId);
			}

			return route.params;
		},
		meta: {
			title: 'Montage'
		}
	},
	{
		path: '/jobs/assembling/:jobId(\\d+)/report/:partId(\\d+)',
		name: 'JobReport',
		component: JobReport,
		props: route => {
			if (route.params.jobId) {
				route.params.jobId = parseInt(route.params.jobId);
			}
			if (route.params.partId) {
				route.params.partId = parseInt(route.params.partId);
			}

			return route.params;
		},
		meta: {
			title: 'Montage'
		}
	},
	{
		path: '/jobs/assembling/:jobId(\\d+)/part/:partId(\\d+)',
		name: 'JobPart',
		component: JobPart,
		props: route => {
			if (route.params.jobId) {
				route.params.jobId = parseInt(route.params.jobId);
			}
			if (route.params.partId) {
				route.params.partId = parseInt(route.params.partId);
			}

			return route.params;
		},
		meta: {
			title: 'Montage'
		}
	}
	//{
	//path: '/about',
	//name: 'About',
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	//component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	//}
];

// Router
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

// Authentication redirecting
router.beforeEach((to, from, next) => {
	let needsAuth = to.matched.some(r => !('meta' in r) || !('requiresAuth' in r.meta) || r.meta.requiresAuth);

	if (needsAuth) {
		if (!store.getters['user/loggedIn']) {
			next({ name: 'Login' });
		} else {
			let profile = store.getters['user/profile'];

			if (to.name != 'Profile' && (profile.updated_at == null || profile.updated_by != profile.user_id)) {
				next({ name: 'Profile' });
			} else {
				next();
			}
		}
	} else {
		next();
	}
});

// Save current route in store
router.afterEach((to, from) => {
	store.commit('navigation/setRoute', to);
});

export default router;
